import React, { useState, useContext } from 'react';
import { FiChevronDown, FiClipboard } from 'react-icons/fi';
import Swal from 'sweetalert2';
import { useSession } from '@/hooks/useSession';
import { ProjectsContext } from './provider';
import { Link } from 'react-router-dom';
import { CardAvatarStack } from '@/components/ui/card-avatar-stack';
import { ProjectForm } from './ProjectForm';
import usePermission from '@/hooks/usePermission';
import { useTranslation } from 'react-i18next';
import { Sheet, SheetBody, SheetContent, SheetTitle } from '@/components/ui/sheet';
import { Button } from '@/components/ui/button';
import { ButtonGroup } from '@/components/ui/button-group';
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from '@/components/ui/dropdown-menu';
import { Card, CardAvatar, CardAvatarTitle, CardBody, CardBodyContent, CardBodyHeader, CardBodyHeaderContent, CardContent, CardFooter, CardIcon, CardIconImg, CardKpiGrid, CardTitle } from '@/components/ui/card';
import { Badge, BadgeGroup } from '@/components/ui/badge';

export function ProjectsCard(props) {
  const { t } = useTranslation();
  const { data } = props;
  const [editShow, setEditShow] = useState(false);
  const { session } = useSession();

  const { setSelectedProject, deleteProject, selectedProject } = useContext(ProjectsContext);

  const handleEdit = project => {
    setSelectedProject(project);
    setEditShow(true);
  };

  // const thereArePendingVersions = projectVersions => {
  //   return projectVersions.some(
  //     pv => pv.approved === null || pv.approved === false,
  //   );
  // };

  const projectUrl = data['project-users']?.some(projectUser => projectUser.user_id === session.user.id) ? `/projetos/${data.id}` : `/projetos/${data.id}/sobre`;

  return (
    <Card>
      <CardContent>
        <CardIcon>
          <CardIconImg>
            <FiClipboard />
          </CardIconImg>
        </CardIcon>

        <CardBody>
          <CardBodyHeader>
            <CardBodyHeaderContent>
              <CardTitle>{data.name}</CardTitle>
            </CardBodyHeaderContent>

            <BadgeGroup>
              {data.approved ? (
                <Badge
                  size="xs"
                  variant="success"
                >
                  {t('exams.statusInApproved')}
                </Badge>
              ) : (
                <Badge
                  size="xs"
                  variant="primary-light"
                >
                  {t('exams.inProgress')}
                </Badge>
              )}
              {/* {thereArePendingVersions(data['project-versions']) ? (
              <Badge size="xs" variant="warning"
              >
                Avaliação pendente
              </Badge>
            ) : null} */}
            </BadgeGroup>
          </CardBodyHeader>

          <CardBodyContent>
            <CardKpiGrid>
              <CardAvatar>
                <CardAvatarTitle>{t('projects.participants')}</CardAvatarTitle>
                <CardAvatarStack
                  data={data?.users}
                  modalTitle={`${t('projects.titleProjectParticipants')} ${data.name}`}
                />
              </CardAvatar>
            </CardKpiGrid>
          </CardBodyContent>
        </CardBody>
      </CardContent>

      <CardFooter>
        <ButtonGroup className="w-full">
          <Button
            variant="outline"
            size="sm"
            fullWidth
            asChild
          >
            <Link to={projectUrl}>{data['project-users']?.some(projectUser => projectUser.user_id === session.user.id) ? t('button.accessProject') : t('button.detailsProject')}</Link>
          </Button>

          {usePermission('Editar projetos', 'Projetos') || usePermission('Excluir projetos', 'Projetos') ? (
            <DropdownMenu>
              <DropdownMenuTrigger asChild>
                <Button
                  variant="outline"
                  size="sm"
                >
                  <FiChevronDown size={20} />
                </Button>
              </DropdownMenuTrigger>

              <DropdownMenuContent align="end">
                {usePermission('Editar projetos', 'Projetos') && <DropdownMenuItem onClick={() => handleEdit(data)}>{t('button.edit')}</DropdownMenuItem>}
                {usePermission('Excluir projetos', 'Projetos') && (
                  <DropdownMenuItem
                    onClick={() => {
                      Swal.fire({
                        title: t('projects.warningDeleteProject'),
                        text: t('projects.warningDeleteCannotBeUndoneText'),
                        confirmButtonText: t('button.yes'),
                        showDenyButton: true,
                        denyButtonText: t('button.no'),
                        showCloseButton: true
                      }).then(res => {
                        if (res.isConfirmed) {
                          deleteProject(data.id);
                        }
                      });
                    }}
                  >
                    {t('textsCommon.delete')}
                  </DropdownMenuItem>
                )}
              </DropdownMenuContent>
            </DropdownMenu>
          ) : null}
        </ButtonGroup>
      </CardFooter>

      <Sheet
        open={editShow}
        onOpenChange={setEditShow}
      >
        <SheetContent>
          <SheetTitle className="sr-only">Editar projeto</SheetTitle>
          <SheetBody className="py-6">
            <ProjectForm
              labelForm={'Editar projeto'}
              labelFormButton={'Editar e continuar'}
              currentProject={selectedProject}
            />
          </SheetBody>
        </SheetContent>
      </Sheet>
    </Card>
  );
}
